export default __webpack_public_path__ + "static/media/bucaramanga.b9406618.png";